<template>
    <SettingsPage title="Ausgeblendete Artikel">
        <b-input id="blacklist-search" v-model="searchInput" placeholder="Suche" />

        <div v-if="filteredBlacklist.length === 0">
            Es konnten keine Artikel gefunden werden.
        </div>
        <Table
            v-else-if="!error"
            :table-data="filteredBlacklist"
            :columns="tableColumns"
            @selected="selectArticles"
        />
        <div v-else>
            Es wurden keine Artikel ausgeblendet.
        </div>
        <SmartButton
            id="blacklist-btn"
            variant="primary"
            :disabled="selectedArticles.length === 0"
            @click="deleteFromBlacklist"
        >
            Artikel nicht mehr ausblenden ({{ selectedArticles.length }})
        </SmartButton>
    </SettingsPage>
</template>

<script>
import Table from "@/views/shared/widgets/Table";
import SettingsPage from "./SettingsPage";
import SmartButton from "@/views/shared/widgets/SmartButton";

export default {
    name: "Blacklist",
    components: { SmartButton, SettingsPage, Table },
    data() {
        return {
            loading: true,
            error: false,
            // DATA
            searchInput: null,
            selectedArticles: [],
            tableColumns: [
                {
                    key: "actions",
                    label: ""
                },
                {
                    key: "pzn",
                    label: "PZN",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Artikel",
                    sortable: true
                },
                {
                    key: "manufacturer",
                    label: "Hersteller",
                    sortable: true
                },
                {
                    key: "waregroup",
                    label: "Warengruppe",
                    sortable: true
                }
            ]
        };
    },
    computed: {
        blacklist() {
            return this.$store.state.blacklist.blacklist;
        },
        filteredBlacklist() {
            if (!this.searchInput) {
                return this.blacklist;
            }
            return this.blacklist.filter(
                item =>
                    item.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                    item.manufacturer.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                    item.waregroup.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                    item.pzn
                        .toString()
                        .toLowerCase()
                        .indexOf(this.searchInput.toLowerCase()) > -1
            );
        }
    },
    created() {
        this.$store
            .dispatch("loadBlacklist")
            .catch(() => {
                this.error = true;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
        async deleteFromBlacklist() {
            await this.$store.dispatch(
                "deleteFromBlacklist",
                this.selectedArticles.map(articles => articles.pzn)
            );
            this.selectedArticles = [];
        },
        selectArticles(list) {
            this.selectedArticles = list;
        }
    }
};
</script>

<style />
